import WithProposalContainer from '../Common/WithProposalContainer'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { PROPOSAL_TYPE_NAME } from '../../constants/proposalTypes'
import UpdateImage from '../../components/BatchProposal/BatchUploadImage'
import WithS3Service from '../Common/WithS3Service'

UpdateImage.fetchData = async ({
  store,
  req,
  res,
  match
}) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const proposalType = PROPOSAL_TYPE.UPDATE_IMAGE

const props = {
  proposalType,
  proposalTypeName: PROPOSAL_TYPE_NAME[proposalType]
}

const MappedContainer = WithProposalContainer(WithS3Service(UpdateImage), props)

export default MappedContainer
